<script>
import CouponForm from './CouponForm'

export default {
  components: { CouponForm },
  props: {
    defaultValue: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    getCoupon() {
      this.$store
        .dispatch('coupon/fetchSingle', this.$route.params.couponId)
        .then((coupon) => {
          this.$emit('update:defaultValue', coupon)
        })
    },
  },
}
</script>
<template>
  <div>
    <BasePageHeader title="編輯優惠券" />
    <el-card>
      <CouponForm :default-value="defaultValue" @store="getCoupon" />
    </el-card>
  </div>
</template>